import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    chartPaper: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        height: "100%"
    }
}));

export {useStyles};